import { render, staticRenderFns } from "./FixedRentalCreate.vue?vue&type=template&id=bc0ff96e&"
import script from "@/scripts/modal/fixedRental/fixedRentalCreate.js?vue&type=script&lang=js&"
export * from "@/scripts/modal/fixedRental/fixedRentalCreate.js?vue&type=script&lang=js&"
import style0 from "./FixedRentalCreate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports